import type { HeroId } from '../types';
import { HEROES } from '../heroes';
import { checksumOf } from './canonical';
import { CRITTER_GATES } from './gates';

const HERO_IDS = Object.keys(HEROES) as HeroId[];

function starterUnlocked(id: HeroId): boolean {
  const gate = CRITTER_GATES.find((row) => row.id === id);
  return gate !== undefined && gate.at === 0;
}

/**
 * A glen saved before the later critters existed has four critter keys.
 * Fill the rest as locked, with an empty loadout, then restamp the checksum.
 * Callers only do this after the stored checksum already matches.
 */
export function adoptRoster(record: Record<string, unknown>): void {
  const critters = record.critters;
  if (!critters || typeof critters !== 'object' || Array.isArray(critters)) return;
  const bag = critters as Record<string, unknown>;
  let changed = false;
  for (const id of HERO_IDS) {
    const row = bag[id];
    const unlocked = row && typeof row === 'object' && !Array.isArray(row) ? (row as { unlocked?: unknown }).unlocked : undefined;
    if (typeof unlocked !== 'boolean') {
      bag[id] = { unlocked: starterUnlocked(id) };
      changed = true;
    }
  }
  const loadouts = record.loadouts;
  if (loadouts && typeof loadouts === 'object' && !Array.isArray(loadouts)) {
    const slots = loadouts as Record<string, unknown>;
    for (const id of HERO_IDS) {
      if (!Array.isArray(slots[id])) {
        slots[id] = [];
        changed = true;
      }
    }
  }
  if (changed) record.checksum = checksumOf(record);
}
